import SPLASH_IMAGE_DARK from 'assets/splash-dark.png'
import SPLASH_IMAGE from 'assets/splash-light.png'
import { Image } from 'components'
import { useThemeBasedImage } from 'hooks'
import React from 'react'
import Skeleton from 'react-loading-skeleton'
import {
  LoadingTitleWrapper,
  MarketDetails,
  PerformanceContainer,
  PerformanceItem,
  PerformanceListWrapper,
  PerformancePageWrapper,
  ProductContainerMobile,
  ProductDetails,
  ProductDetailsContainer,
  ProductImageWrapper,
  ProductNameAndDescription,
  StyledHeader,
} from '../pages/exposure-mobile/style'
import {
  ProductsPromoContainer,
  SmartProductItem,
  SmartProductsList,
  SmartSecureProducts,
} from '../pages/smart-products/mobile/style'
import {
  ContentColumn,
  ContentContainerMobile,
  ImageContainer,
  ImageWrapper,
  SkeletonWrapper,
  SplashContainer,
  Wrapper,
} from '../pages/splash/style'
import { MobileOverviewContainer, OverViewWrapper, WhitePaperContainerMobile } from '../styled'

export const MobileOverviewLoading: React.FC = () => {
  const splashImage = useThemeBasedImage(SPLASH_IMAGE, SPLASH_IMAGE_DARK)
  return (
    <OverViewWrapper>
      <MobileOverviewContainer>
        <Wrapper isLoading>
          <SplashContainer>
            <ContentContainerMobile>
              <ImageWrapper>
                <ImageContainer>
                  <Image src={splashImage} />
                </ImageContainer>
              </ImageWrapper>
              <ContentColumn>
                <SkeletonWrapper>
                  <Skeleton width={260} height={48} />
                  <Skeleton width={230} height={48} />
                </SkeletonWrapper>
                <div>
                  <Skeleton width={280} />
                  <Skeleton width={240} />
                </div>
                <Skeleton width={150} height={37} borderRadius="1.5rem" />
              </ContentColumn>
            </ContentContainerMobile>
          </SplashContainer>
        </Wrapper>
        <SkeletonWrapper>
          <Skeleton width={'100%'} height={100} />
        </SkeletonWrapper>
        <PerformancePageWrapper>
          <SplashContainer>
            <PerformanceContainer id="content">
              <LoadingTitleWrapper>
                <Skeleton width={240} height={36} />
                <Skeleton width={280} height={36} />
              </LoadingTitleWrapper>
              <PerformanceListWrapper>
                <PerformanceItem>
                  <ProductDetails>
                    <ProductImageWrapper>
                      <SkeletonWrapper>
                        <Skeleton circle={true} height={48} width={48} />
                      </SkeletonWrapper>
                    </ProductImageWrapper>
                    <ProductNameAndDescription>
                      <div>
                        <Skeleton width={120} />
                      </div>
                      <div>
                        <Skeleton width={80} />
                      </div>
                    </ProductNameAndDescription>
                  </ProductDetails>
                  <ProductContainerMobile>
                    <ProductDetailsContainer>
                      <StyledHeader>
                        <Skeleton width={60} />
                      </StyledHeader>
                      <SkeletonWrapper>
                        <Skeleton width={60} />
                      </SkeletonWrapper>
                    </ProductDetailsContainer>
                    <ProductDetailsContainer>
                      <StyledHeader>
                        <Skeleton width={60} />
                      </StyledHeader>
                      <SkeletonWrapper>
                        <Skeleton width={60} />
                      </SkeletonWrapper>
                    </ProductDetailsContainer>
                    <ProductDetailsContainer>
                      <StyledHeader />
                      <SkeletonWrapper>
                        <Skeleton width={60} />
                      </SkeletonWrapper>
                    </ProductDetailsContainer>
                  </ProductContainerMobile>
                  <MarketDetails>
                    <Skeleton width={280} height={30} borderRadius="1.35rem" />
                  </MarketDetails>
                </PerformanceItem>
                <PerformanceItem>
                  <ProductDetails>
                    <ProductImageWrapper>
                      <SkeletonWrapper>
                        <Skeleton circle={true} height={48} width={48} />
                      </SkeletonWrapper>
                    </ProductImageWrapper>
                    <ProductNameAndDescription>
                      <div>
                        <Skeleton width={120} />
                      </div>
                      <div>
                        <Skeleton width={80} />
                      </div>
                    </ProductNameAndDescription>
                  </ProductDetails>
                  <ProductContainerMobile>
                    <ProductDetailsContainer>
                      <StyledHeader>
                        <Skeleton width={60} />
                      </StyledHeader>
                      <SkeletonWrapper>
                        <Skeleton width={60} />
                      </SkeletonWrapper>
                    </ProductDetailsContainer>
                    <ProductDetailsContainer>
                      <StyledHeader>
                        <Skeleton width={60} />
                      </StyledHeader>
                      <SkeletonWrapper>
                        <Skeleton width={60} />
                      </SkeletonWrapper>
                    </ProductDetailsContainer>
                    <ProductDetailsContainer>
                      <StyledHeader />
                      <SkeletonWrapper>
                        <Skeleton width={60} />
                      </SkeletonWrapper>
                    </ProductDetailsContainer>
                  </ProductContainerMobile>
                  <MarketDetails>
                    <Skeleton width={280} height={30} borderRadius="1.35rem" />
                  </MarketDetails>
                </PerformanceItem>
                <PerformanceItem>
                  <ProductDetails>
                    <ProductImageWrapper>
                      <SkeletonWrapper>
                        <Skeleton circle={true} height={48} width={48} />
                      </SkeletonWrapper>
                    </ProductImageWrapper>
                    <ProductNameAndDescription>
                      <div>
                        <Skeleton width={120} />
                      </div>
                      <div>
                        <Skeleton width={80} />
                      </div>
                    </ProductNameAndDescription>
                  </ProductDetails>
                  <ProductContainerMobile>
                    <ProductDetailsContainer>
                      <StyledHeader>
                        <Skeleton width={60} />
                      </StyledHeader>
                      <SkeletonWrapper>
                        <Skeleton width={60} />
                      </SkeletonWrapper>
                    </ProductDetailsContainer>
                    <ProductDetailsContainer>
                      <StyledHeader>
                        <Skeleton width={60} />
                      </StyledHeader>
                      <SkeletonWrapper>
                        <Skeleton width={60} />
                      </SkeletonWrapper>
                    </ProductDetailsContainer>
                    <ProductDetailsContainer>
                      <StyledHeader />
                      <SkeletonWrapper>
                        <Skeleton width={60} />
                      </SkeletonWrapper>
                    </ProductDetailsContainer>
                  </ProductContainerMobile>
                  <MarketDetails>
                    <Skeleton width={280} height={30} borderRadius="1.35rem" />
                  </MarketDetails>
                </PerformanceItem>
              </PerformanceListWrapper>
            </PerformanceContainer>
          </SplashContainer>
        </PerformancePageWrapper>
        <WhitePaperContainerMobile>
          <SkeletonWrapper>
            <Skeleton width={'100%'} height={316} />
          </SkeletonWrapper>
        </WhitePaperContainerMobile>
        <SmartSecureProducts>
          <ProductsPromoContainer>
            <SkeletonWrapper>
              <Skeleton width={257} height={32} />
              <Skeleton width={157} height={32} />
            </SkeletonWrapper>
          </ProductsPromoContainer>
          <SmartProductsList>
            <SmartProductItem>
              <ProductsPromoContainer>
                <Skeleton width={257} height={100} />
              </ProductsPromoContainer>
              <div>
                <Skeleton width={257} />
                <Skeleton width={125} />
              </div>
            </SmartProductItem>
            <SmartProductItem>
              <ProductsPromoContainer>
                <Skeleton width={257} height={100} />
              </ProductsPromoContainer>
              <div>
                <Skeleton width={257} />
                <Skeleton width={125} />
              </div>
            </SmartProductItem>
            <SmartProductItem>
              <ProductsPromoContainer>
                <Skeleton width={257} height={100} />
              </ProductsPromoContainer>
              <div>
                <Skeleton width={257} />
                <Skeleton width={125} />
              </div>
            </SmartProductItem>
          </SmartProductsList>
        </SmartSecureProducts>
        <SkeletonWrapper>
          <Skeleton width={'100%'} height={100} />
        </SkeletonWrapper>
        <SmartSecureProducts>
          <ProductsPromoContainer>
            <SkeletonWrapper>
              <Skeleton width={300} height={32} />
            </SkeletonWrapper>
          </ProductsPromoContainer>
          <SmartProductsList>
            <SmartProductItem>
              <ProductsPromoContainer>
                <Skeleton width={257} height={50} />
              </ProductsPromoContainer>
              <div>
                <Skeleton width={125} />
              </div>
            </SmartProductItem>
            <SmartProductItem>
              <ProductsPromoContainer>
                <Skeleton width={257} height={50} />
              </ProductsPromoContainer>
              <div>
                <Skeleton width={125} />
              </div>
            </SmartProductItem>
            <SmartProductItem>
              <ProductsPromoContainer>
                <Skeleton width={257} height={50} />
              </ProductsPromoContainer>
              <div>
                <Skeleton width={125} />
              </div>
            </SmartProductItem>
          </SmartProductsList>
        </SmartSecureProducts>
      </MobileOverviewContainer>
    </OverViewWrapper>
  )
}
